import React from "react";
import { Typography } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";

const OffenseTeam = ({ title, onChange, offenseTeamId, controls = [] }) => {
	return (
		<>
			<Typography variant="h5">{title}</Typography>
			<FormControl component="fieldset">
				<RadioGroup
					row
					aria-label="offense team"
					name="offenseTeam"
					value={offenseTeamId ?? ""}
					onChange={onChange}
				>
					{controls.map(({ id, value, label }) => (
						<FormControlLabel
							id={id}
							value={value}
							control={<Radio color="primary" />}
							label={label}
						/>
					))}
				</RadioGroup>
			</FormControl>
		</>
	);
};

export default OffenseTeam;
